<template>
  <section class="section elo-progress-container">
    <h2 class="section-heading">Postęp <span class="text-accent">ELO</span></h2>
    <div class="elo-bar-container">
      <div class="progress-bar-container">
        <progress
          class="progress-bar"
          :value="playerInfo.faceit_elo"
          max="2149"
        ></progress>
        <EloBarLegend />
      </div>
    </div>
  </section>
</template>

<script>
import EloBarLegend from "./EloBarLegend";

export default {
  name: "EloProgress",
  components: {
    EloBarLegend
  },
  props: ["playerInfo"]
};
</script>
